import React, { useState, useEffect, useRef } from 'react';
import './candidatesearch.css';
import { MasterDataService } from '../../../../services/masterDataService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

const CandidateSearchForm = ({ onSubmit, juniorerrorMessage, setJuniorErrorMessage, hasSearched }) => {
    const [formData, setFormData] = useState({
        designation: '',
        yearsOfExpMin: '',
        yearsOfExpMax: '',
        industries: [],
        functions: [],
        juniorProfile: '',
        locations: [],
        ctcMin: '',
        ctcMax: '',
    });

    const [cities, setCities] = useState([]);
    const [filteredCities, setFilteredCities] = useState([]);
    const [loadingCities, setLoadingCities] = useState(false);
    const [showDropdown, setShowDropdown] = useState(false);
    const [errors, setErrors] = useState({});
    const [errorMessage, setErrorMessage] = useState('');
    const cityDropdownRef = useRef(null);
    const [showIndustryDropdown, setShowIndustryDropdown] = useState(false);
    const industryDropdownRef = useRef(null);
    const [industryInput, setIndustryInput] = useState("");
    const [currentIndustry, setCurrentIndustry] = useState("");
    const [currentSubCategory, setCurrentSubCategory] = useState("");
    const [currentSubCategories, setCurrentSubCategories] = useState([]);
    const [industrySectors, setIndustrySectors] = useState([]);
    const [functions, setFunctions] = useState([]);
    const [functionSubcategories, setFunctionSubcategories] = useState([]);
    const [currentFunction, setCurrentFunction] = useState('');
    const [currentFunctionSub, setCurrentFunctionSub] = useState('');


    const [showFunctionPopup, setShowFunctionPopup] = useState(false);
    const [showIndustryPopup, setShowIndustryPopup] = useState(false);

    const [selectedIndustryPairs, setSelectedIndustryPairs] = useState([]);
    const [selectedFunctionPairs, setSelectedFunctionPairs] = useState([]);

    const [selectedLocations, setSelectedLocations] = useState([]);

    const isPopupOpen = showFunctionPopup || showIndustryPopup;

    const selectedFunctionPairsRef = useRef(selectedFunctionPairs);
    const selectedIndustryPairsRef = useRef(selectedIndustryPairs);

    useEffect(() => {
        selectedFunctionPairsRef.current = selectedFunctionPairs;
    }, [selectedFunctionPairs]);

    useEffect(() => {
        selectedIndustryPairsRef.current = selectedIndustryPairs;
    }, [selectedIndustryPairs]);



    useEffect(() => {
        const fetchIndustrySectors = async () => {
            try {
                const res = await MasterDataService.getAllIndustrySectors();
                setIndustrySectors(res.data || []);
            } catch (e) {
                setIndustrySectors([]);
            }
        };
        fetchIndustrySectors();
    }, []);
    const handleIndustryChange = async (industryId) => {
        setCurrentIndustry(industryId);
        setCurrentSubCategory("");

        try {
            const res = await MasterDataService.getIndustrySubcategories(industryId);
            setCurrentSubCategories(res.data || []);
        } catch (e) {
            setCurrentSubCategories([]);
        }
    };

    const triggerAutoSearch = (updatedFormData) => {
        if (!hasSearched) return;
        const allEmpty = Object.values(updatedFormData).every((val) => {
            if (Array.isArray(val)) return val.length === 0;
            if (val === null || val === undefined) return true;
            if (typeof val === "string") return val.trim() === "";
            return false;
        });

        sessionStorage.setItem("searchFormData", JSON.stringify(updatedFormData));

        if (allEmpty) {
            sessionStorage.removeItem("filteredResults");
            sessionStorage.removeItem("totalPages");
            onSubmit(null);
        } else {
            onSubmit(updatedFormData);
        }
    };

    const addLocation = (location) => {
        if (!location) return;
        if (selectedLocations.includes(location)) return;

        const updated = [...selectedLocations, location];

        setSelectedLocations(updated);
        setFormData(prev => ({
            ...prev,
            locations: updated
        }));
    };


    const removeLocation = (idx) => {
        const updated = selectedLocations.filter((_, i) => i !== idx);

        const updatedFormData = {
            ...formData,
            locations: updated
        };

        setSelectedLocations(updated);
        setFormData(updatedFormData);
        triggerAutoSearch(updatedFormData);
    };


    const addIndustryPair = () => {
        if (!currentIndustry) return;

        const industryName = industrySectors.find(
            i => i.id == currentIndustry
        )?.industrySector;

        const subCategoryName = currentSubCategories.find(
            sc => sc.id == currentSubCategory
        )?.subcategory;

        const exists = selectedIndustryPairs.some(
            i =>
                i.industryName === industryName &&
                (i.subCategoryName || "") === (subCategoryName || "")
        );

        if (exists) return;

        const updated = [
            ...selectedIndustryPairs,
            {
                industryId: currentIndustry,
                subCategoryId: currentSubCategory || null,
                industryName,
                subCategoryName: subCategoryName || null
            }
        ];

        setSelectedIndustryPairs(updated);

        setFormData(prev => ({
            ...prev,
            industries: updated.map(i => ({
                fieldValue: i.industryName,
                subcategory: i.subCategoryName
            }))
        }));

        setCurrentIndustry('');
        setCurrentSubCategory('');
        setCurrentSubCategories([]);
    };


    const removeIndustryPair = (idx, { silent = false } = {}) => {
        const updated = selectedIndustryPairsRef.current.filter((_, i) => i !== idx);
        setSelectedIndustryPairs(updated);

        if (silent || isPopupOpen) return;

        const updatedFormData = {
            ...formData,
            industries: updated.map(i => ({
                fieldValue: i.industryName,
                subcategory: i.subCategoryName
            }))
        };

        setFormData(updatedFormData);
        triggerAutoSearch(updatedFormData);
    };


    useEffect(() => {
        const fetchCities = async () => {
            setLoadingCities(true);
            try {
                const response = await MasterDataService.getAllCities();
                if (Array.isArray(response.data)) {
                    setCities(response.data);
                    setFilteredCities(response.data);
                } else if (response.data?.cities) {
                    setCities(response.data.cities);
                    setFilteredCities(response.data.cities);
                } else {
                    console.error("Unexpected API response format", response.data);
                    setCities([]);
                    setFilteredCities([]);
                }
            } catch (error) {
                console.error("Error fetching cities:", error);
                setCities([]);
                setFilteredCities([]);
            } finally {
                setLoadingCities(false);
            }
        };
        fetchCities();
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (cityDropdownRef.current && !cityDropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
            if (industryDropdownRef.current && !industryDropdownRef.current.contains(event.target)) {
                setShowIndustryDropdown(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        let sanitizedValue = value;
        let errorMessage = '';

        if (name === 'yearsOfExpMin' || name === 'yearsOfExpMax' || name === "ctcMin" || name === "ctcMax") {
            if (value.includes('-')) {
                errorMessage = `${name} cannot be negative.`;
            } else if (!/^\d*$/.test(value)) {
                errorMessage = `Only numbers are allowed in ${name}.`;
            }
            sanitizedValue = value.replace(/[^0-9]/g, '');
        }

        if (["designation"].includes(name)) {
            if (!/^[a-zA-Z\s,-]*$/.test(value)) {
                errorMessage = `Only letters, comma(,), hypen(-) are allowed in ${name}.`;
            }
            sanitizedValue = value.replace(/[^a-zA-Z\s,-]/g, '');
        }

        if (name === "specialisation") {
            if (!/^[a-zA-Z0-9\s]*$/.test(value)) {
                errorMessage = "Please avoid special characters.";
            }
            sanitizedValue = value.replace(/[^a-zA-Z0-9\s]/g, '');
        }

        setFormData((prevData) => {
            const updatedData = { ...prevData, [name]: sanitizedValue };
            if (
                name === "ctcMin" &&
                updatedData.ctcMax &&
                sanitizedValue !== '' &&
                parseInt(sanitizedValue, 10) > parseInt(updatedData.ctcMax, 10)
            ) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    ctcMax: 'CTC Min cannot be greater than CTC Max.',
                }));
            } else if (name === "ctcMax" && updatedData.ctcMin) {
                if (parseInt(updatedData.ctcMin, 10) > parseInt(sanitizedValue, 10)) {
                    setErrors((prevErrors) => ({
                        ...prevErrors,
                        ctcMax: 'CTC Min cannot be greater than CTC Max.',
                    }));
                } else {
                    setErrors((prevErrors) => ({ ...prevErrors, ctcMax: '' }));
                }
            }

            // ---------- EXPERIENCE Min–Max validation (NEW) ----------
            if (

                name === "yearsOfExpMin" &&
                updatedData.yearsOfExpMax &&
                sanitizedValue !== '' &&
                parseInt(sanitizedValue, 10) > parseInt(updatedData.yearsOfExpMax, 10)
            ) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    yearsOfExpMax: 'Experience Min cannot be greater than Max.',
                }));
            } else if (
                name === "yearsOfExpMax" &&
                updatedData.yearsOfExpMin
            ) {
                if (parseInt(updatedData.yearsOfExpMin, 10) > parseInt(sanitizedValue, 10)) {
                    setErrors((prevErrors) => ({
                        ...prevErrors,
                        yearsOfExpMax: 'Experience Min cannot be greater than Max.',
                    }));
                } else {
                    setErrors((prevErrors) => ({ ...prevErrors, yearsOfExpMax: '' }));
                }
            }

            if (sanitizedValue === '') {
                const allEmpty = Object.values(updatedData).every((val) => {
                    if (Array.isArray(val)) return val.length === 0;
                    if (val === null || val === undefined) return true;
                    if (typeof val === "string") return val.trim() === "";
                    return false;
                });

                sessionStorage.setItem('searchFormData', JSON.stringify(updatedData));

                if (allEmpty) {
                    sessionStorage.removeItem('filteredResults');
                    sessionStorage.removeItem('totalPages');
                    onSubmit(null);
                } else {
                    onSubmit(updatedData);
                }
            } else {
                sessionStorage.setItem('searchFormData', JSON.stringify(updatedData));
            }

            return updatedData;
        });

        setErrors((prevErrors) => ({ ...prevErrors, [name]: errorMessage }));

        if (errorMessage === '' && errorMessage !== 'Please enter the inputs before searching.') {
            setErrorMessage('');
        }
    };

    useEffect(() => {
        if (performance.navigation.type === performance.navigation.TYPE_RELOAD) {
            sessionStorage.clear();
            setFormData({
                designation: '',
                experience: '',
                industry: '',
                city: '',
                specialisation: '',
                ctcMin: '',
                ctcMax: '',
            });
        } else {
            const savedFormData = sessionStorage.getItem('searchFormData');
            if (savedFormData) {
                const parsed = JSON.parse(savedFormData);
                setFormData({
                    ...formData,
                    ...parsed,
                    industries: Array.isArray(parsed.industries)
                        ? parsed.industries
                        : parsed.industries
                            ? [parsed.industries]
                            : [],
                });
            }
        }
    }, []);
    useEffect(() => {
        const savedFormData = sessionStorage.getItem("searchFormData");
        if (!savedFormData) return;

        const parsed = JSON.parse(savedFormData);

        if (Array.isArray(parsed.industries)) {
            const restoredIndustryPairs = parsed.industries.map((i) => ({
                industryName: i.fieldValue,
                subCategoryName: i.subcategory || null,
            }));

            setSelectedIndustryPairs(restoredIndustryPairs);
        }

        if (Array.isArray(parsed.functions)) {
            const restoredFunctionPairs = parsed.functions.map((f) => ({
                functionName: f.fieldValue,
                subcategory: f.subcategory || null,
            }));

            setSelectedFunctionPairs(restoredFunctionPairs);
        }
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault();

        let tempPairs = [...selectedIndustryPairs];

        // if (currentIndustry) {
        //     const industryName = industrySectors.find(i => i.id == currentIndustry)?.industrySector;
        //     const subCategoryName = currentSubCategories.find(sc => sc.id == currentSubCategory)?.subcategory;

        //     tempPairs.push({
        //         industryId: currentIndustry,
        //         subCategoryId: currentSubCategory || "",
        //         industryName,
        //         subCategoryName: subCategoryName || ""
        //     });
        // }

        formData.industries = tempPairs.map(i => ({
            fieldValue: i.industryName,
            subcategory: i.subCategoryName || ""

        }));

        let tempFunctionPairs = [...selectedFunctionPairs];

        // if (currentFunction) {
        //     const functionName = functions.find(f => f.id == currentFunction)?.function;
        //     const subName = functionSubcategories.find(s => s.id == currentFunctionSub)?.subcategory;

        //     const exists = tempFunctionPairs.some(
        //         f =>
        //             f.functionName === functionName &&
        //             (f.subcategory || "") === (subName || "")
        //     );

        //     if (!exists) {
        //         tempFunctionPairs.push({
        //             functionName,
        //             subcategory: subName || ""
        //         });
        //     }
        // }

        formData.functions = tempFunctionPairs.map(f => ({
            fieldValue: f.functionName,
            subcategory: f.subcategory
        }));


        const filteredFormData = Object.fromEntries(
            Object.entries(formData).filter(([key, value]) => {
                if (Array.isArray(value)) return value.length > 0;
                return value.toString().trim();
            })
        );

        const industryInputTrimmed = industryInput.trim();

        if (
            industryInputTrimmed &&
            !industries.some(
                (ind) => ind.toLowerCase() === industryInputTrimmed.toLowerCase()
            )
        ) {
            setErrorMessage("Please enter a valid input from industry field dropdown.");
            return;
        }

        if (Object.keys(filteredFormData).length === 0) {
            setErrorMessage('Please enter the inputs before searching.');
            return;
        }

        sessionStorage.setItem('searchFormData', JSON.stringify(filteredFormData));

        onSubmit(filteredFormData);
    };

    useEffect(() => {
        const fetchFunctions = async () => {
            try {
                const res = await MasterDataService.getAllFunctions();
                setFunctions(res.data || []);
            } catch {
                setFunctions([]);
            }
        };
        fetchFunctions();
    }, []);

    const handleFunctionChange = async (id) => {
        setCurrentFunction(id);
        setCurrentFunctionSub('');

        try {
            const res = await MasterDataService.getFunctionSubcategories(id);
            setFunctionSubcategories(res.data || []);
        } catch {
            setFunctionSubcategories([]);
        }
    };

    const addFunctionPair = () => {
        if (!currentFunction) return;

        const functionName = functions.find(f => f.id == currentFunction)?.function;
        const subName = functionSubcategories.find(
            s => s.id == currentFunctionSub
        )?.subcategory;

        const exists = selectedFunctionPairs.some(
            f =>
                f.functionName === functionName &&
                (f.subcategory || "") === (subName || "")
        );

        if (exists) return;

        const updated = [
            ...selectedFunctionPairs,
            { functionName, subcategory: subName || null }
        ];

        setSelectedFunctionPairs(updated);

        setFormData(prev => ({
            ...prev,
            functions: updated.map(f => ({
                fieldValue: f.functionName,
                subcategory: f.subcategory
            }))
        }));

        setCurrentFunction('');
        setCurrentFunctionSub('');
        setFunctionSubcategories([]);
    };



    const removeFunctionPair = (idx, { silent = false } = {}) => {
        const updated = selectedFunctionPairsRef.current.filter((_, i) => i !== idx);
        setSelectedFunctionPairs(updated);

        if (silent || isPopupOpen) return;

        const updatedFormData = {
            ...formData,
            functions: updated.map(f => ({
                fieldValue: f.functionName,
                subcategory: f.subcategory
            }))
        };

        setFormData(updatedFormData);
        triggerAutoSearch(updatedFormData);
    };


    const handleAddAndCloseFunction = () => {
        addFunctionPair();
        setShowFunctionPopup(false);
        setCurrentFunction('');
        setCurrentFunctionSub('');
        setFunctionSubcategories([]);
    };

    const handleAddMoreFunction = () => {
        addFunctionPair();
        setCurrentFunction('');
        setCurrentFunctionSub('');
        setFunctionSubcategories([]);
    };

    const handleAddAndCloseIndustry = () => {
        addIndustryPair();
        setShowIndustryPopup(false);
        setCurrentIndustry('');
        setCurrentSubCategory('');
        setCurrentSubCategories([]);
    };

    const handleAddMoreIndustry = () => {
        addIndustryPair();
        setCurrentIndustry('');
        setCurrentSubCategory('');
        setCurrentSubCategories([]);
    };

    return (
        <div className='client-search-candidate-container'>
            {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
            {juniorerrorMessage && (
                <div className="custom-alert-overlay">
                    <div className="custom-alert-box">
                        <div className="custom-alert-content">
                            <p>{juniorerrorMessage}</p>
                            <button
                                className="candidate-alert-button"
                                onClick={() => setJuniorErrorMessage('')}
                            >
                                OK
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <form onSubmit={handleSubmit} className='client-search-candidate-card'>
                <div className="row mb-4">
                    <div className="col-md-3">
                        <div className="client-search-candidate-input-group">
                            <span className="client-search-candidate-input-icon">
                                <i className="fas fa-user-tie"></i>
                            </span>
                            <input
                                type="text"
                                className={`client-search-candidate-input ${errors.designation ? 'error' : ''}`}
                                id="designation"
                                name="designation"
                                placeholder="Designation (e.g., CEO, CFO, GM)"
                                value={formData.designation}
                                onChange={handleInputChange}
                                spellCheck={false}
                            />
                        </div>
                        {errors.designation && <span className="error-message">{errors.designation}</span>}
                    </div>

                    <div className="col-md-3">

                        <div style={{ display: "flex", gap: "8px" }}>
                            <div className="client-search-candidate-input-group" style={{ flex: 1 }}>
                                <span className="client-search-candidate-input-icon">
                                    <i className="fas fa-briefcase"></i>
                                </span>
                                <input
                                    readOnly
                                    className="client-search-candidate-input"
                                    placeholder="Function"
                                    value=""
                                    onClick={() => setShowFunctionPopup(true)}
                                />

                            </div>

                        </div>

                        {/* Function badges */}
                        <div style={{ marginTop: "6px", display: "flex", gap: "8px", flexWrap: "wrap" }}>
                            {selectedFunctionPairs.map((f, idx) => (
                                <span
                                    key={idx}
                                    style={{
                                        background: "#e8f1ff",
                                        color: '#000',
                                        padding: "6px 10px",
                                        borderRadius: "20px",
                                        display: "inline-flex",
                                        alignItems: "center",
                                        gap: "6px",
                                        fontSize: "13px",
                                        fontWeight: '500'
                                    }}
                                >
                                    {f.functionName}
                                    {f.subcategory && (
                                        <>
                                            {" "}→{" "}
                                            {f.subcategory}
                                        </>
                                    )}
                                    <button
                                        type="button"
                                        onClick={() => removeFunctionPair(idx)}
                                        style={{
                                            background: "transparent",
                                            border: "none",
                                            cursor: "pointer",
                                            color: "#f35824",
                                            fontWeight: "bold",
                                            fontSize: "15px",
                                        }}
                                    >
                                        ×
                                    </button>
                                </span>
                            ))}
                        </div>
                    </div>
                    <div className="col-md-3">

                        <div
                            style={{
                                display: "flex",
                                gap: "8px",
                                marginBottom: "10px",
                                alignItems: "center",
                            }}
                        >
                            <div className="client-search-candidate-input-group" style={{ flex: 1 }}>
                                <span className="client-search-candidate-input-icon">
                                    <i className="fas fa-industry"></i>
                                </span>

                                {/* Industry Dropdown */}
                                <input
                                    readOnly
                                    className="client-search-candidate-input"
                                    placeholder="Industry"
                                    value=""
                                    onClick={() => setShowIndustryPopup(true)}
                                />

                            </div>
                            {/* Subcategory Dropdown */}

                        </div>

                        {/* ----------- BADGES ----------- */}
                        <div style={{ marginTop: "6px", display: "flex", flexWrap: "wrap", gap: "8px" }}>
                            {selectedIndustryPairs.map((row, idx) => (
                                <span
                                    key={idx}
                                    style={{
                                        background: "#e8f1ff",
                                        padding: "6px 10px",
                                        borderRadius: "20px",
                                        display: "inline-flex",
                                        alignItems: "center",
                                        gap: "6px",
                                        fontSize: "13px",
                                    }}
                                >
                                    {row.industryName}
                                    {row.subCategoryName && (
                                        <>
                                            {" "}→{" "}
                                            {row.subCategoryName}
                                        </>
                                    )}
                                    <button
                                        type="button"
                                        onClick={() => removeIndustryPair(idx)}
                                        style={{
                                            background: "transparent",
                                            border: "none",
                                            cursor: "pointer",
                                            color: "#f35824",
                                            fontWeight: "bold",
                                            fontSize: "15px",
                                        }}
                                    >
                                        ×
                                    </button>
                                </span>
                            ))}
                        </div>

                    </div>

                    <div className="col-md-3">
                        <div className="client-search-candidate-input-group">
                            <span className="client-search-candidate-input-icon">
                                <i className="fas fa-location"></i>
                            </span>
                            <select
                                className="client-search-candidate-input"
                                onChange={(e) => {
                                    addLocation(e.target.value);
                                    e.target.value = "";
                                }}
                            >
                                <option value="">Location</option>
                                {cities.map((city, idx) => (
                                    <option key={idx} value={city}>{city}</option>
                                ))}
                            </select>
                        </div>

                        {/* Location badges */}
                        <div style={{ marginTop: "6px", display: "flex", gap: "8px", flexWrap: "wrap" }}>
                            {selectedLocations.map((loc, idx) => (
                                <span
                                    key={idx}
                                    style={{
                                        background: "#e8f1ff",
                                        padding: "6px 10px",
                                        borderRadius: "20px",
                                        display: "inline-flex",
                                        alignItems: "center",
                                        gap: "6px",
                                        fontSize: "13px",
                                        fontWeight: "500"
                                    }}
                                >
                                    {loc}
                                    <button
                                        type="button"
                                        onClick={() => removeLocation(idx)}
                                        style={{
                                            background: "transparent",
                                            border: "none",
                                            cursor: "pointer",
                                            color: "#f35824",
                                            fontWeight: "bold",
                                            fontSize: "15px",
                                        }}
                                    >
                                        ×
                                    </button>
                                </span>
                            ))}
                        </div>
                    </div>


                </div>
                <div className="row mb-4">

                    {/* Experience Min */}
                    <div className="col-md-3">
                        <div className="client-search-candidate-input-group">
                            <span className="client-search-candidate-input-icon">
                                <i className="fas fa-clock"></i>
                            </span>
                            <input
                                type="text"
                                className={`client-search-candidate-input ${errors.yearsOfExpMin ? 'error' : ''}`}
                                id="yearsOfExpMin"
                                name="yearsOfExpMin"
                                placeholder="Experience Min (Years)"
                                value={formData.yearsOfExpMin}
                                onChange={handleInputChange}
                                spellCheck={false}
                            />
                        </div>
                        {errors.yearsOfExpMin && (
                            <span className="error-message">{errors.yearsOfExpMin}</span>
                        )}
                    </div>

                    {/* Experience Max */}
                    <div className="col-md-3">
                        <div className="client-search-candidate-input-group">
                            <span className="client-search-candidate-input-icon">
                                <i className="fas fa-clock"></i>
                            </span>
                            <input
                                type="text"
                                className={`client-search-candidate-input ${errors.yearsOfExpMax ? 'error' : ''}`}
                                id="yearsOfExpMax"
                                name="yearsOfExpMax"
                                placeholder="Experience Max (Years)"
                                value={formData.yearsOfExpMax}
                                onChange={handleInputChange}
                                spellCheck={false}
                            />
                        </div>
                        {errors.yearsOfExpMax && (
                            <span className="error-message">{errors.yearsOfExpMax}</span>
                        )}
                    </div>

                    <div className="col-md-3">
                        <div className="client-search-candidate-input-group">
                            <span className="client-search-candidate-input-icon">
                                <i className="fas fa-money-bill-wave"></i>
                            </span>
                            <input
                                type="text"
                                className={`client-search-candidate-input ${errors.ctcMin ? 'error' : ''}`}
                                id="ctcMin"
                                name="ctcMin"
                                placeholder="CTC Min (Lakhs)"
                                value={formData.ctcMin}
                                onChange={handleInputChange}
                                spellCheck={false}
                            />
                        </div>
                        {errors.ctcMin && <span className="error-message">{errors.ctcMin}</span>}
                    </div>
                    <div className="col-md-3">
                        <div className="client-search-candidate-input-group">
                            <span className="client-search-candidate-input-icon">
                                <i className="fas fa-money-bill-wave"></i>
                            </span>
                            <input
                                type="text"
                                className={`client-search-candidate-input ${errors.ctcMax ? 'error' : ''}`}
                                id="ctcMax"
                                name="ctcMax"
                                placeholder="CTC Max (Lakhs)"
                                value={formData.ctcMax}
                                onChange={handleInputChange}
                                spellCheck={false}
                            />
                        </div>
                        {errors.ctcMax && <span className="error-message">{errors.ctcMax}</span>}
                    </div>

                </div>

                <div className="text-center">
                    <button type="submit" className="searchcandidate-searchbar-button">
                        Search
                    </button>
                </div>
            </form>
            {showFunctionPopup && (
                <div className="popup-overlay">
                    <div className="popup-box">

                        <button className="popup-close-btn" onClick={() => setShowFunctionPopup(false)}>
                            <FontAwesomeIcon icon={faTimes} />
                        </button>

                        <h5>Select Function</h5>

                        <div className="popup-fields-horizontal">
                            <select
                                className="client-search-candidate-input"
                                value={currentFunction}
                                onChange={(e) => handleFunctionChange(e.target.value)}
                            >
                                <option value="">Function</option>
                                {functions.map(f => (
                                    <option key={f.id} value={f.id}>
                                        {f.function}
                                    </option>
                                ))}
                            </select>

                            <select
                                className="client-search-candidate-input"
                                value={currentFunctionSub}
                                disabled={!currentFunction}
                                onChange={(e) => setCurrentFunctionSub(e.target.value)}
                            >
                                <option value="">Subcategory</option>
                                {functionSubcategories.map(sc => (
                                    <option key={sc.id} value={sc.id}>
                                        {sc.subcategory}
                                    </option>
                                ))}
                            </select>
                        </div>

                        {/* Selected Functions INSIDE popup */}
                        {selectedFunctionPairs.length > 0 && (
                            <div style={{ marginTop: "10px", display: "flex", flexWrap: "wrap", gap: "8px" }}>
                                {selectedFunctionPairs.map((f, idx) => (
                                    <span
                                        key={idx}
                                        style={{
                                            background: "#e8f1ff",
                                            padding: "6px 10px",
                                            borderRadius: "20px",
                                            fontSize: "12px",
                                            display: "inline-flex",
                                            alignItems: "center",
                                            gap: "6px"
                                        }}
                                    >
                                        {f.functionName}
                                        {f.subcategory && <> → {f.subcategory}</>}
                                        <button
                                            type="button"
                                            onClick={() => removeFunctionPair(idx, { silent: true })}
                                            style={{
                                                background: "transparent",
                                                border: "none",
                                                cursor: "pointer",
                                                color: "#f35824",
                                                fontWeight: "bold"
                                            }}
                                        >
                                            ×
                                        </button>
                                    </span>
                                ))}
                            </div>
                        )}

                        <div className="popup-actions">
                            <button onClick={handleAddAndCloseFunction}>Add</button>
                            <button onClick={handleAddMoreFunction}>Add More</button>
                        </div>

                    </div>
                </div>
            )}

            {showIndustryPopup && (
                <div className="popup-overlay">
                    <div className="popup-box">

                        <button className="popup-close-btn" onClick={() => setShowIndustryPopup(false)}>
                            <FontAwesomeIcon icon={faTimes} />
                        </button>

                        <h5>Select Industry</h5>
                        <div className="popup-fields-horizontal">

                            <select
                                className="client-search-candidate-input"
                                value={currentIndustry}
                                onChange={(e) => handleIndustryChange(e.target.value)}
                            >
                                <option value="">Industry</option>
                                {industrySectors.map(i => (
                                    <option key={i.id} value={i.id}>
                                        {i.industrySector}
                                    </option>
                                ))}
                            </select>

                            <select
                                className="client-search-candidate-input"
                                value={currentSubCategory}
                                disabled={!currentIndustry}
                                onChange={(e) => setCurrentSubCategory(e.target.value)}
                            >
                                <option value="">Subcategory</option>
                                {currentSubCategories.map(sc => (
                                    <option key={sc.id} value={sc.id}>
                                        {sc.subcategory}
                                    </option>
                                ))}
                            </select>
                        </div>

                        {/* Selected Industries INSIDE popup */}
                        {selectedIndustryPairs.length > 0 && (
                            <div style={{ marginTop: "10px", display: "flex", flexWrap: "wrap", gap: "8px" }}>
                                {selectedIndustryPairs.map((row, idx) => (
                                    <span
                                        key={idx}
                                        style={{
                                            background: "#e8f1ff",
                                            padding: "6px 10px",
                                            borderRadius: "20px",
                                            fontSize: "12px",
                                            display: "inline-flex",
                                            alignItems: "center",
                                            gap: "6px"
                                        }}
                                    >
                                        {row.industryName}
                                        {row.subCategoryName && <> → {row.subCategoryName}</>}
                                        <button
                                            type="button"
                                            onClick={() => removeIndustryPair(idx, { silent: true })}
                                            style={{
                                                background: "transparent",
                                                border: "none",
                                                cursor: "pointer",
                                                color: "#f35824",
                                                fontWeight: "bold"
                                            }}
                                        >
                                            ×
                                        </button>
                                    </span>
                                ))}
                            </div>
                        )}

                        <div className="popup-actions">
                            <button onClick={handleAddAndCloseIndustry}>Add</button>
                            <button onClick={handleAddMoreIndustry}>Add More</button>
                        </div>

                    </div>
                </div>
            )}

        </div>

    );

};

export default CandidateSearchForm;